import { CARE_APPOINTMENT_ERROR_CODES } from '@galapagos/shared';
import { SignupRequestError } from '../services/signup-api/signup-api';

/**
 * How a failed booking recovers: `slot-taken` (the time went, or was stale)
 * re-reads the times; anything else can simply be tried again.
 */
export type BookingFailure = 'slot-taken' | 'generic';

export function classifyBookingFailure(error: unknown): BookingFailure {
  if (!(error instanceof SignupRequestError)) return 'generic';
  if (
    error.code === CARE_APPOINTMENT_ERROR_CODES.slotTaken ||
    error.code === CARE_APPOINTMENT_ERROR_CODES.invalidSlot
  ) {
    return 'slot-taken';
  }
  return 'generic';
}
